import { render, staticRenderFns } from "./ClListItemText.html?vue&type=template&id=10a9ceaa&"
import script from "./ClListItemText.ts?vue&type=script&lang=ts&"
export * from "./ClListItemText.ts?vue&type=script&lang=ts&"
import style0 from "./ClListItemText.css?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports